import { useCallback } from 'react'

import toNumber from 'lodash/toNumber'
import { config } from '../../../Init/Init'
import { tokenizer } from '../../../../services/utils'
import l10n from '../../../i18n/I18N'
import { usePut } from '../../../../hooks/apiHooks'
import { withdrawFormFields } from '../../cryptoPaymentConstants'
import { usePlayerStore } from '../../../../services/store'

export const useUpdateDraftWithdrawal = ({
  uuid,
  loading,
  setLoading,
  isXRPCryptoType,
  setWithdrawalDraftData,
  setWithdrawalFormError
}) => {
  const playerStore = usePlayerStore()
  const playerUserId = playerStore.use.userId()

  const { PUT } = usePut()

  const updateDraftWithdrawal = useCallback(
    values => {
      if (loading || !uuid) {
        return
      }

      setWithdrawalFormError('')
      setLoading(true)

      const formData = {
        [withdrawFormFields.address]: values.address,
        [withdrawFormFields.currency]: values.currency,
        [withdrawFormFields.destinationTag]: isXRPCryptoType ? toNumber(values.destinationTag) : null,
        [withdrawFormFields.protocol]: values.protocol
      }

      return PUT(
        config.paymentsUrl +
          tokenizer(config.updateWithdrawalDraftUrl, {
            '{userId}': playerUserId,
            '{uuid}': uuid
          }),
        formData
      )
        .then(async response => {
          setLoading(false)
          if (response.errorCode) {
            setWithdrawalFormError(
              config.enableSweepstakes
                ? l10n.t['cryptopayment.redeem.updateError']
                : l10n.t['cryptopayment.withdraw.updateError']
            )
          } else {
            setWithdrawalDraftData(response)
          }
        })
        .catch(e => {
          setLoading(false)

          if (config.enableSweepstakes) {
            setWithdrawalFormError(l10n.t['cryptopayment.redeem.updateError'])
            console.error('[CryptoPaymentModal] Failed updating redemption request!', e)
          } else {
            setWithdrawalFormError(l10n.t['cryptopayment.withdraw.updateError'])
            console.error('[CryptoPaymentModal] Failed updating withdraw request!', e)
          }
        })
    },
    [loading, uuid, setWithdrawalFormError, setLoading, isXRPCryptoType, PUT, playerUserId, setWithdrawalDraftData]
  )

  return { updateDraftWithdrawal }
}
